export const buildMutationVariables = (variables, options) => {
  const preferences = options.map((option) => ({ id: option.id, name: option.name }));
  return {
    ...variables,
    preferences,
  };
};

export const buildMutationPrivacyVariables = (variables, consent) => {
  return {
    ...variables,
    status: consent,
  };
};
